import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2 } from "lucide-react";

const STATUSES = [
  { v: "new", l: "Nuevo", color: "text-arre-red" },
  { v: "contacted", l: "Contactado", color: "text-orange-400" },
  { v: "quoted", l: "Cotizado", color: "text-yellow-300" },
  { v: "won", l: "Ganado", color: "text-green-400" },
  { v: "lost", l: "Perdido", color: "text-white/40" },
];

export default function AdminCorporateLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/corporate-leads").then((r) => {
      setLeads(r.data);
      setLoading(false);
    });
  };
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.patch(`/admin/corporate-leads/${id}?status=${status}`);
    load();
  };

  return (
    <div className="p-8 md:p-12" data-testid="admin-corporate">
      <div className="mb-8">
        <div className="text-xs tracking-[0.35em] uppercase text-arre-red mb-2">⟡ Admin</div>
        <h1 className="font-display text-4xl md:text-5xl tracking-wider uppercase text-white leading-none">Leads corporativos</h1>
      </div>
      <div className="bg-arre-surface border border-arre-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-arre-border text-[10px] tracking-[0.2em] uppercase text-white/50">
              <th className="text-left p-4">Empresa</th>
              <th className="text-left p-4">Contacto</th>
              <th className="text-left p-4">Empleados</th>
              <th className="text-left p-4">Presupuesto</th>
              <th className="text-left p-4">Ocasión</th>
              <th className="text-left p-4">Estado</th>
              <th className="text-left p-4">Fecha</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="7" className="p-8 text-center text-white/50">Cargando...</td></tr>}
            {!loading && leads.length === 0 && (
              <tr><td colSpan="7" className="p-10 text-center">
                <Building2 className="w-10 h-10 text-white/20 mx-auto mb-3" />
                <div className="text-white/50">Sin leads corporativos aún.</div>
              </td></tr>
            )}
            {leads.map((l) => {
              const s = STATUSES.find(s => s.v === l.status) || STATUSES[0];
              return (
                <tr key={l.id} className="border-b border-arre-border/50" data-testid={`lead-${l.id}`}>
                  <td className="p-4">
                    <div className="font-display text-white">{l.company}</div>
                    {l.message && <div className="text-xs text-white/40 italic max-w-xs truncate">{l.message}</div>}
                  </td>
                  <td className="p-4">
                    <div className="text-white">{l.contact_name}</div>
                    <div className="text-xs text-white/50">{l.email}</div>
                    <div className="text-xs text-white/50">{l.phone}</div>
                  </td>
                  <td className="p-4 text-white/70">{l.employees_count || "—"}</td>
                  <td className="p-4 text-white/70">{l.budget_range || "—"}</td>
                  <td className="p-4 text-white/70 capitalize">{l.occasion || "—"}</td>
                  <td className="p-4">
                    <select
                      value={l.status}
                      onChange={(e) => updateStatus(l.id, e.target.value)}
                      className={`bg-arre-black border border-arre-border px-2 py-1 text-xs font-bold ${s.color} focus:outline-none focus:border-arre-red`}
                      data-testid={`lead-status-${l.id}`}
                    >
                      {STATUSES.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}
                    </select>
                  </td>
                  <td className="p-4 text-xs text-white/50">
                    {new Date(l.created_at).toLocaleDateString("es-MX")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
